<div class="availability">
  <small class="availability-title">Assentos disponíveis</small>
  <div class="availability-list">
    @for (item of items; track $index) {
      <span class="availability-pill">
        <span
          class="availability-dot"
          [class.availability-dot--available]="item.availableSeats !== undefined && item.availableSeats !== null && item.availableSeats > 0"
          [class.availability-dot--empty]="item.availableSeats === 0"
          [class.availability-dot--loading]="item.availableSeats === undefined"
          [class.availability-dot--unavailable]="item.availableSeats === null"
          aria-hidden="true">
        </span>
        @if (items.length > 1) {
          <span>LA{{ item.flightNumber }}:&nbsp;</span>
        }
        <strong>
          @if (item.availableSeats === undefined) {
            ...
          } @else if (item.availableSeats === null) {
            —
          } @else {
            {{ item.availableSeats }}
          }
        </strong>
      </span>
    }
  </div>
</div>
